import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/Store';
import type { SuggestionPill } from '../store/schema/SuggestionPill';

/**
 * Mutator to set SuggestionPill in the search store.
 */
export default mutatorAction(
    'setSuggestionPill',
    function setSuggestionPill(suggestionPill: SuggestionPill) {
        getStore().suggestionPill = suggestionPill;
    }
);
